import { useMemo } from "react";
import { CheckCircleIcon } from "staysure-component-library";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import ToggleBtnLabelWrapper from "@/components/atoms/toggle-btn-wrapper/toggle-btn-label-wrapper";

import Styles from "./option-selection.module.css";
import { useCoverTypeContext } from "../../../provider/cover-type.provider";
import { CoverTypeOptionSelectionType } from "../../../types/cover-type.type";
import brandClassNames from "../../../utils/cover-type.utils";

function OptionSelection({
  options,
  onOptionSelect,
}: Readonly<CoverTypeOptionSelectionType>) {
  const { isCoverTypeModalOpen, toggleWrapperRef, magnoliaData } =
    useCoverTypeContext();
  const { current } = useWizard();
  const showNewButtonsLayout = current.uiElementControls?.showNewButtonsLayout;
  const { toggleBtnText } = brandClassNames;
  const { ctaButtonOneDescription, ctaButtonTwoDescription } =
    magnoliaData.overlayArea[0];

  const optionDescriptions: Record<number, string | undefined> = useMemo(
    () => ({
      1: ctaButtonOneDescription,
      2: ctaButtonTwoDescription,
    }),
    [ctaButtonOneDescription, ctaButtonTwoDescription]
  );

  return (
    <div
      data-testid="button-group-test-id"
      className={`flex flex-col gap-spacing-s mt-spacing-l ${
        showNewButtonsLayout
          ? "w-full max-w-[280px] mx-auto md:max-w-none"
          : "md:flex-row lg:flex-col lg:w-[414px] md:w-[400px] w-full"
      }`}
      ref={toggleWrapperRef}
    >
      {options?.map(({ id, isSelected, labelValue }) => {
        return (
          <ToggleBtnLabelWrapper
            data-testid={`cover-type-buttons-group-${id}`}
            id={`toggleButton-${id}`}
            key={`toggleButton-${id}`}
            label={labelValue}
            isToggleEnable={false}
            isDefaultActive={isCoverTypeModalOpen ? id === 1 : isSelected}
            isDisabled={false}
            btnType="button"
            onClick={() => {
              onOptionSelect(id, labelValue);
            }}
            isActiveRightIcon
            activeRightIcon={<CheckCircleIcon />}
            className={` active:bg-interactive-secondary-default active:text-dark-text-on-primary border-[1px]
            bg-surface-neutral-option-1
            border-interactive-secondary-default
            text-text-on-primary w-full rounded-lg text-2xs text-left
            font-body-font leading-[24px] flex flex-col justify-center self-start
            gap-grid-system-space-050 ${Styles.policy_togglebtn_wrapper} ${
              Styles.toggle_btn
            } ${toggleBtnText}
            hover:bg-interactive-action-hovered ${
              showNewButtonsLayout
                ? `h-[69px] p-spacing-s ${Styles.new_layout}`
                : "h-[56px] py-spacing-l px-spacing-s hover:px-[11px]"
            }`}
            description={
              showNewButtonsLayout ? optionDescriptions[id] : undefined
            }
          />
        );
      })}
    </div>
  );
}

export default OptionSelection;
